const REMOTE_THEME_QUERY = 'remoteTheme';
const DEFAULT_THEME = 'facelift';

let forcedTheme: string | undefined;
let originalReplaceState: History['replaceState'] | undefined;

const reassertThemeQuery = () => {
  if (!forcedTheme) return;

  const url = new URL(window.location.href);
  if (url.searchParams.get(REMOTE_THEME_QUERY) === forcedTheme) return;

  url.searchParams.set(REMOTE_THEME_QUERY, forcedTheme);
  const replace = originalReplaceState ?? window.history.replaceState.bind(window.history);
  replace.call(window.history, window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

const patchHistory = (method: 'pushState' | 'replaceState') => {
  const original = window.history[method].bind(window.history);
  if (method === 'replaceState') originalReplaceState = original;

  window.history[method] = (...args: Parameters<History['pushState']>) => {
    original(...args);
    reassertThemeQuery();
  };
};

export const forceRemoteTheme = () => {
  forcedTheme = new URL(window.location.href).searchParams.get(REMOTE_THEME_QUERY) ?? DEFAULT_THEME;

  patchHistory('pushState');
  patchHistory('replaceState');
  window.addEventListener('popstate', reassertThemeQuery);
  reassertThemeQuery();
};
